export enum ExtraType {
  Cancellation = "CANCELLATION",
  Weekend = "WEEKEND",
  WaitingTime = "WAITING_TIME",
  Manual = "MANUAL",
  PalletExchange = "PALLET_EXCHANGE",
  TwoManHandling = "TWO_MAN_HANDLING",
  Discount = "DISCOUNT",
  Liftgate = "LIFTGATE",
  Sideloading = "SIDELOADING",
  Forklift = "FORKLIFT",
  RigidBox = "RIGID_BOX",
  NeutralVehicle = "NEUTRAL_VEHICLE",
  RampLoadable = "RAMP_LOADABLE",
  LargeWindowDiscount = "LARGE_WINDOWS_DISCOUNT"
}
